









































































































































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import VueToastr from '@deveodk/vue-toastr';
import { vxm } from './../store.vuex';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import CandidatePortalLogo from './CandidatePortalLogo.vue';
import router from '../router';
import Avatar from 'vue-avatar';
import { Job } from '@/models/jobs/job';
import LocalJobs from '../components/Commons/LocalJobs.vue';
import ReferFriendModal from '@/components/Commons/ReferFriendModal.vue';
import { SIDE_MENU_ROUTE_MAPPER } from '@/models/configs/RoutersMap';
import { AVAILABLE_SIDEMENU_OPTIONS } from '@/components/Commons/availableSideMenuOptions';

@Component({
  name: 'Header',
  components: {
    CandidatePortalLogo,
    Avatar,
    LocalJobs,
    ReferFriendModal,
  },
})
export default class Header extends Vue {
  $wlToastr: any;
  private showAvatar: boolean = true;
  private uploadProfileFileUrl: string = '';

  private ALIAS_TO_SECTION_KEY_MAPPER = {
    findJobs: 'FIND_JOBS',
    referafriend: 'REFER_A_FRIEND',
    myJobs: 'MY_JOBS',
    myReferrals: 'MY_REFERRALS',
    job_alerts: 'JOB_ALERTS',
    savedJobs: 'SAVED_JOBS',
    chat: 'INBOX',
  };

  get applicationName() {
    return vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
    );
  }
  handleExternalLink(value) { 
    if (typeof value === 'object' && value.externalLink) {
      window.open(value.externalLink, '_blank');
      this.$router.go(-1);
    }
    if (vxm.jobs.BrandingInfo.OPEN_TIMESHEET_IN_NEW_TAB && value.alias === 'timesheets') {
      const currentDomain = window.location.origin;
      window.open(currentDomain + '/atsuser/candidate-timesheet', '_blank');
      this.$router.go(-1);
    }
    this.closeMenu();

  }
  onClickOnReferFriend() {
    if (this.showReferFriendPopup) {
      this.showReferAFriendPopup();
    } else {
      this.$router.push(
        this.isLoggedIn ? '/referafriend' : '/anonreferafriend',
      );
    }
  }

  get defaultLandingPageAsFindjobs() {
    return !vxm.configs.getGlobalConfigBooelanValue(
      'DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN',
    );
  }

  get findJobsRedirectionLink() {
    return vxm.configs.getGlobalConfigValue(
      'CANDIDATE_PORTAL_COMPANY_FINDJOB_REDIRECTION_LINK',
    );
  }

  redirectToRoute(routeName) {
    this.$cookies.remove('OAuthRegistrationType');
    this.$cookies.remove('OAuthProvider');
    this.$router.push({ name: routeName });
  }

  get canShowReferAFriend() {
    return this.isLoggedIn
      ? this.referralEnabled
      : this.canShowReferAFriendBeforeLogin;
  }

  get showAnonymousSavedJobs() {
    return (
      !this.isLoggedIn &&
      vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS')
    );
  }

  get canShowHeaderLinks() {
    return (
      vxm.utility.CanShowHeaderLinks && this.$route.query.view !== 'simple'
    );
  }

  get profileLink() {
    return vxm.configs.getGlobalConfigValue('ENABLE_USER_PROFILE_V2')
      ? // ? '/myprofileaccordian/details'
        '/myprofile/v2/details'
      : '/myprofile/details';
  }

  get userDeviceToken() {
    return vxm.users.UserDeviceAppTkn || vxm.utility.UserDeviceToken;
  }

  getImgUrl(name) {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return require('../assets/images2.0/menu-icons/' + name + '.svg');
    }
    return require('../assets/images2.0/menu-icons/' + name);
  }

  get isConfigJSONEnabled() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return true;
    }
    return false;
  }

  get leftMenuOptions() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const config = vxm.configs.ClientConfigs.globalConfig.config.find(
        (config) => config.key === 'CHECK_USER_PROFILE_FORUM_ENABLED_FLAG',
      );
      if (config && config.value && !vxm.users.myUserProfile.enableForum) {
        this.lodash.remove(vxm.configs.ClientConfigs.slideMenuOptions, {
          sectionKey: 'FORUM',
        });
      }
      if (!vxm.configs.isReferralEnabled('REFERRAL_ENABLED')) {
        this.lodash.remove(vxm.configs.ClientConfigs.slideMenuOptions, {
          sectionKey: 'MY_REFERRALS',
        });
      }
      return vxm.configs.ClientConfigs.slideMenuOptions.filter((option) =>
        AVAILABLE_SIDEMENU_OPTIONS.includes(option.sectionKey),
      );
    }
    return vxm.utility.leftMenuOptions;
  }

  getMenuText(menu) {
    const appNameParam = {
      ApplicationName: this.applicationName,
    };
    let defaultText = '';

    let normalizedKey = '';
    if (this.isConfigJSONEnabled) {
      normalizedKey = menu.sectionKey.toLowerCase();
      defaultText = menu.displayName;
    } else {
      normalizedKey = this.ALIAS_TO_SECTION_KEY_MAPPER[menu.alias]
        ? this.ALIAS_TO_SECTION_KEY_MAPPER[menu.alias].toLowerCase()
        : menu.alias;
      defaultText = menu.text.replace(
        /{ApplicationName}/g,
        this.applicationName,
      );
    }
    const label = this.$t(`sidemenu.${normalizedKey}`, appNameParam).toString();

    return label.indexOf('sidemenu') >= 0 ? defaultText : label;
  }

  get canShowReferAFriendBeforeLogin() {
    if (this.referralEnabled) {
      return !vxm.configs.getGlobalConfigBooelanValue(
        'REFERFRIEND_AFTER_LOGIN_ONLY',
      );
    }
    return false;
  }

  get referralEnabled() {
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  public localjobs: Job[] = [];
  get localJobCount() {
    let res = 0;
    let jobs = vxm.utility.localjobs;
    var utilJobscnt = jobs.length;
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
      console.log('local jobs:' + localStorage.localjobs);
    }
    if (utilJobscnt >= this.localjobs.length) res = utilJobscnt;
    else res = this.localjobs.length;
    return res;
  }

  handleCloseMenu(e) {
    e.stopPropagation();
    this.closeMenu();
  }

  menuLink(name) {
    if (name === 'JOB_ALERTS') {
      const jobAlertURL = vxm.configs.ClientConfigs.globalConfig.config.find(
        (config) => config.key === 'ENABLE_JOBALERT_V2',
      );
      if (jobAlertURL && jobAlertURL.value) {
        return '/jobAlertV2';
      }
      return '/jobAlert';
    }
    return SIDE_MENU_ROUTE_MAPPER[name];
  }

  closeMenu() {
    console.log('Close Menu', 'Closed');
    const elem = document.getElementById('navbarNav');
    if (elem) {
      elem.classList.remove('show');
    }
  }

  logout() {
    vxm.users.logout();
    this.$router.push('/');
  }
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get showReferFriendPopup() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED');
  }

  get FullName() {
    return (
      vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName
    );
  }

  setProfilePicture() {
    this.uploadProfileFileUrl =
      vxm.users.myUserProfile.userProfileBasePath +
      vxm.users.myUserProfile.profilePicGUID +
      '.' +
      vxm.users.myUserProfile.profilePicExtType;

    let response = false;
    if (vxm.users.myUserProfile.profilePicGUID == null) {
      response = true;
    } else if (!this.uploadProfileFileUrl) {
      response = true;
    }
    this.showAvatar = response;
  }

  mounted() {
    let vm = this;
    if (vxm.users.isLoggedIn && this.$route.name !== 'MyProfileDetailsNew') {
      const resp: any = vxm.users.refreshProfileInfo();
      Promise.all([resp]).then((values) => {
        if (values[0]) {
          vm.setProfilePicture();
        }
      });
    }
  }

  get dndStatus() {
    return vxm.users.myUserProfile.availabilityStatus;
  }

  openLocalJobs() {
    const vm = this;
    if (this.localJobCount == 0) {
      vm.$wlToastr('success', 'There are no saved jobs', vm.$t('savedJobs.text'));
    } else {
      this.$modal.show('localjobsmodal');
    }
  }

  showReferAFriendPopup() {
    this.$modal.show('refer-friend-popup');
  }

  get canShowSignup(): boolean {
    return !this.isLoggedIn && !vxm.utility.useLoginSignupV2;
  }

  get loginText(): string {
    return this.canShowSignup ? 'menu.top.login' : 'menu.top.login.signup';
  }
}
